export default __webpack_public_path__ + "static/media/marginalia-done.65535690.svg";